import { useState } from 'react';
import { GridApi } from '@ag-grid-community/core';

export function useGridSearch({ gridApi }: { gridApi?: GridApi | null }) {
    const [displayedTotal, setDisplayedTotal] = useState(0);
    const [quickFilterText, setFilterText] = useState('');
    const onFilterTextChange = (value: string) => setFilterText(value);
    const onModelUpdated = () => {
        if (!gridApi) return;
        setDisplayedTotal(gridApi.getDisplayedRowCount());
    };

    return {
        displayedTotal,
        quickFilterText,
        onFilterTextChange,
        onModelUpdated,
    };
}
